export enum REQUEST_LIFE_CICLE {
  IDLE = 'idle',
  PENDING = 'pending',
  SUCCEEDED = 'succeeded',
  FAILED = 'failed',
}

export interface IMyKnownError {
  message: string;
}

export interface IListRequestParams {
  limit?: number;
  offset?: number;
  orderDirection?: string;
  orderBy?: string;
  filterBy?: string;
  filterValue?: string;
}

export interface IPaginatedListResponse<T> {
  count: number;
  values: T[];
}

export interface ICreateRequestPayload<T> {
  item: T;
  resetFormSubmitting: () => void;
}
